import { authConfig } from "../apiConfig";

// for get all completed equipment reports
export const get_equipment_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`EquipmentReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};